import { render } from "./UsuariosTable.vue?vue&type=template&id=45484c56&ts=true"
import script from "./UsuariosTable.vue?vue&type=script&lang=ts"
export * from "./UsuariosTable.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__